import { render, staticRenderFns } from "./VersionsDialog.vue?vue&type=template&id=6120f9cd&scoped=true&"
import script from "./VersionsDialog.vue?vue&type=script&lang=ts&"
export * from "./VersionsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./VersionsDialog.vue?vue&type=style&index=0&id=6120f9cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120f9cd",
  null
  
)

export default component.exports